import QUERY from 'constants/queryKeys';

import exercisesApi from './exercises';
import { toExerciseId } from './exercises.types';

/** Shared key so Main / navigation / note reuse one GET /exercises/{id}/. */
export const classicExerciseQueryKey = (exerciseId: string | null | undefined) =>
  [QUERY.GET_CLASSIC_EXERCISE, exerciseId] as const;

/**
 * Draw restore uses its own key so opening/saving drawings does not fight the
 * classic viewer cache (double fetch / remount on save).
 */
export const exerciseDrawQueryKey = (exerciseId: string | null | undefined) =>
  [QUERY.GET_EXERCISE_DRAW, exerciseId] as const;

export const classicExerciseQueryFn = (exerciseId: string) => exercisesApi.getClassic(toExerciseId(exerciseId));

export const CLASSIC_EXERCISE_STALE_TIME_MS = 60_000;
